export function getVisitorId(): string {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    // The visitor ID is the credential for unauthenticated preference and
    // history access — generate it with a CSPRNG, not Math.random.
    const bytes = new Uint8Array(9);
    crypto.getRandomValues(bytes);
    const suffix = Array.from(bytes, (b) => b.toString(36).padStart(2, '0')).join('');
    visitorId = `visitor_${suffix}`;
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
}
